import React from "react";
import styles from "./CollectionYardVisitItem.module.scss";
import { formattedDateTime, Icons } from "../../../utils";
import { CollectionYardVisit } from "../../../types/collectionYards";
import { formatCurrency } from "../../../utils/currency";
import { formatWeight } from "../../../utils/weight";
import { Icon } from "../../Icon";
import { IsPaidStatus } from "../../../components/IsPaidStatus";

type CollectionYardVisitProps = {
  visit: CollectionYardVisit;
};

export const CollectionYardVisitItem: React.FC<CollectionYardVisitProps> = ({ visit }) => {
  const { visitId, wasteSum, created, priceSum, paid } = visit;

  return (
    <div className={styles.item} key={visitId}>
      <div className={styles.itemContent}>
        <h6 className={styles.itemTitle}>
          <div>{formattedDateTime(new Date(created))}</div>
        </h6>
        <div className={styles.wasteTypes}>
          <span>{formatWeight(wasteSum)}</span>
          <span className={styles.divider} />
          <span>{formatCurrency(priceSum)}</span>
        </div>
      </div>
      <div className={styles.itemPaymentStatus}>
        <IsPaidStatus paymentStatus={paid} />
      </div>
      <div className={styles.verticalDivider} />
      <div className={styles.itemActions}>
        <Icon
          style={{
            width: "1.5rem",
            height: "auto",
            gridArea: "1/3/3/3",
            justifySelf: "flex-end",
            alignSelf: "center",
          }}
          name={Icons.arrowRight}
        />
      </div>
    </div>
  );
};
